import type { OnInit, PipeTransform } from '@angular/core';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, Pipe } from '@angular/core';
// TODO: Fix enforce-module-boundaries errors
// eslint-disable-next-line @nx/enforce-module-boundaries
import { TtComVideo, TtComVideoPicture, VideoProvider } from '@candyland/generic/tt-com-shared-overviews';

@Component({
    selector: 'nmo-video-container-v3',
    templateUrl: './video-container-v3.component.html',
    styleUrls: ['./video-container-v3.component.scss'],
    standalone: false
})
export class VideoContainerV3Component implements OnInit {
  @Input() groups: TtComVideo[][];
  @Input() defaultVideo: TtComVideo;
  @Output() groupChange: EventEmitter<number> = new EventEmitter<GroupIndex>();

  selectedVideo: TtComVideo;
  showVideoIFrame = false;
  currentSlideIndex = 0;

  constructor(private changeDetection: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.selectedVideo = this.defaultVideo;
  }

  buildEmbedUrl(video: TtComVideo): string {
    let embedUrl = video.embedUrl;

    switch (video.provider) {
      case VideoProvider.APA:
        embedUrl += '?autoplay=1&autoplaymode=default';
        break;
      case VideoProvider.VIMEO:
        embedUrl += '&autoplay=1';
        break;
      default:
        break;
    }

    return embedUrl;
  }

  selectVideo(groupIdx: number, itemIdx: number): void {
    this.showVideoIFrame = true;
    this.selectedVideo = this.groups[groupIdx][itemIdx];
  }

  toggleThumb(): void {
    this.showVideoIFrame = true;
    this.changeDetection.detectChanges();
  }

  slideChanged(groupIdx: number): void {
    this.currentSlideIndex = groupIdx;
    this.groupChange.emit(groupIdx);
  }

  // only show current, previous + next slide
  // lazy load remaining slides for better performance
  showSlide(groupIdx: number): boolean {
    return (
      groupIdx === this.currentSlideIndex ||
      groupIdx === this.currentSlideIndex - 1 ||
      groupIdx === this.currentSlideIndex + 1
    );
  }

  buildImgSourceSet(video: TtComVideo): string {
    return video.pictures.map((picture: TtComVideoPicture) => `${picture.url} ${picture.width}w`).join(', ');
  }
}

@Pipe({
    name: 'decodeHtmlString',
    standalone: false
})
export class DecodeHtmlString implements PipeTransform {
  transform(value: string): string {
    const tempElement: HTMLDivElement = document.createElement('div');
    tempElement.innerHTML = value;
    return tempElement.innerText;
  }
}

export type GroupIndex = number;
